import React from "react";

const AdditionalDetailsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49.76"
      height="34.754"
      viewBox="0 0 49.76 34.754"
    >
      <g
        id="Group_1388"
        data-name="Group 1388"
        transform="translate(-385.973 -176.783)"
      >
        <path
          id="Path_1744"
          data-name="Path 1744"
          d="M372.72,210.76h23.2V214h-23.2Z"
          transform="translate(39.816 -9.024)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1745"
          data-name="Path 1745"
          d="M372.72,283.97h14.991v3.244H372.72Z"
          transform="translate(39.816 -75.677)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Subtraction_2"
          data-name="Subtraction 2"
          d="M18725.2-14985.562H18704a16.791,16.791,0,0,1,16.771-16.771h1.52a16.66,16.66,0,0,1,9.605,3.029,10.45,10.45,0,0,0-7.371,10.025,10.478,10.478,0,0,0,.676,3.716Zm-3.674-17.6a8.432,8.432,0,0,1-8.422-8.421,8.429,8.429,0,0,1,8.422-8.416,8.428,8.428,0,0,1,8.42,8.416A8.43,8.43,0,0,1,18721.529-15003.161Z"
          transform="translate(-18318.027 15196.781)"
          fill={fill ? fill : "#43e57a"}
        />
      </g>
    </svg>
  );
};

export default AdditionalDetailsIcon;
